import React from "react";
import {connect} from "react-redux";
import {LinkContainer} from "react-router-bootstrap";
import {
    Breadcrumb,
    ButtonGroup,
    DropdownButton,
    Button,
    MenuItem,
    Col,
    Row,
    Table,
    Form,
    FormGroup,
    FormControl,
    ControlLabel,
    InputGroup,
    Modal,
    Glyphicon, Checkbox,
} from "react-bootstrap";
import DatetimeRangePicker from "../../DatetimeRangePicker";
import moment from "moment";
import Request from "request";
import RichEditor from "../../RichEditor";
import Loading from "../../Loading";

const RemindersTable = ({reminders, onEdit, onSubmit, onDelete}) => {
	if (!reminders) {
		return null;
	}

	const recipientsSources = {
		registered: 'Регистрация',
		watched: 'Зрители',
		custom: 'Заданный список',
		ticket: 'Владельцы билетов'
	};

	const statuses = {
		waiting: 'Ожидает',
		process: 'В работе',
		error: 'Ошибка',
		done: 'Завершено'
	};

	return (
		<Table>
			<thead>
			<tr>
				<th>ID</th>
				<th>Источник получателей</th>
				<th>Тема письма</th>
				<th>Время отправки</th>
				<th>Статус</th>
				<th>&nbsp;</th>
			</tr>
			</thead>
			<tbody>
			{reminders.map((reminder, index) =>
				<tr key={index}>
					<td>{reminder.id}</td>
					<td>{recipientsSources[reminder.recipientsSource]}</td>
					<td>{reminder.subject}</td>
					<td>{reminder.sendAt ? moment.unix(reminder.sendAt).format('YYYY-MM-DD HH:mm:ss') : 'Нет'}</td>
					<td>{statuses[reminder.status]}</td>
					<td style={{textAlign: 'right'}}>
						<ButtonGroup>
							<Button onClick={() => onEdit(reminder)}>Править</Button>
							<Button onClick={() => onSubmit(reminder)}>Отправить сейчас</Button>
							<Button onClick={() => onDelete(reminder)} bsStyle="danger">Удалить</Button>
						</ButtonGroup>
					</td>
				</tr>
			)}
			</tbody>
		</Table>
	);
};

class ReminderEditor extends React.Component
{
	constructor(props, context)
	{
		super(props, context);

		this.state = {
			view: 'reminder',
			sheets: null,
			sheetIndex: 0,
			selectedColumn: 0,
			selectedRow: 0,
			recipients: [],
			appendRecipientEmail: '',
            posterFile: null,
		};

        this.posterUploadRef = null;
	}

	UNSAFE_componentWillReceiveProps(props)
	{
		const reminder = props.reminder || {};
		const sendType = reminder.sendAt ? 'time' : 'manual';

		const defaultState = {
			sendType
		};

		this.setState(Object.assign({}, reminder, defaultState));
	}

	showReceiversFileRequest()
	{
		const fileInput = document.createElement('input');
		fileInput.setAttribute('type', 'file');
		fileInput.setAttribute('accept', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
		fileInput.addEventListener('change', (e) => {
			const file = e.target.files[0];
			if (!file) {
				console.log('File not select');
				return;
			}

			Request.post(`/api/cp/excel/parseFile`, {file})
				.then(sheets => this.setState({sheets}))
			;

		}, false);
		fileInput.click();
	}

	showRecipients()
	{
		const {event, reminder} = this.props;

		Request.get(`/api/cp/event/${event.eventPassword}/reminder/${reminder.id}/recipient`)
			.then(recipients => {
				this.setState({recipients, view: 'recipients'});
			})
		;
	}

	showEmailPreview()
	{
		const {onSave, reminder} = this.props;

		onSave(reminder, this.state)
			.then(() => {
				this.setState({view: 'email_preview'});
			})
		;
	}

	saveChanges()
	{
		const {onSave, onClose, reminder} = this.props;

		return onSave(reminder, this.state)
			.then(() => {
				onClose();
			})
		;
	}

    handlePosterSelectClick() {
        this.posterUploadRef.click();
    }
    handlePosterSelect(e) {
        const file = e.target.files[0];
        if (!file) {
            return;
        }

        this.setState({posterFile: file});
    }
    handlePosterDelete() {
        this.setState({posterFile: 'DELETE', posterUrl: null});
    }

	renderSheets()
	{
		const {onClose, reminder, event} = this.props;
		const {sheets, sheetIndex, selectedColumn, selectedRow} = this.state;
		const sheet = sheets[sheetIndex];
		const maxRowsShow = 8;

		const sheetFiltered = sheet.slice(0, maxRowsShow);
		let columnCount = 0;
		sheet.forEach(row => Object.keys(row).forEach(index => columnCount = Math.max(columnCount, parseInt(index) + 1)));
		const columns = new Array(columnCount).fill(true).map((n, index) => baseConvert(index));

		function baseConvert(number, letters) {
			letters = letters || new Array(26).fill(true).map((n, index) => String.fromCharCode(65 + index));

			if(number >= 0 && number < letters.length) {
				return letters[number];
			}

			return baseConvert(parseInt(number/letters.length) - 1) + baseConvert(number%letters.length);
		}

		const nextStep = () => {
			const emails = sheet.slice(selectedRow).map(row => row[selectedColumn])
				.filter(email => !!email)
				.filter((value, index, self) => self.indexOf(value) === index)
			;

			Request.post(`/api/cp/event/${event.eventPassword}/reminder/${reminder.id}/recipient`, {emails})
				.then((appendedRecipients) => {
					const recipients = this.state.recipients.slice().concat(appendedRecipients);

					this.setState({
						recipients,
						sheets: null,
						sheetIndex: 0,
						selectedColumn: 0,
						selectedRow: 0
					});
				})
			;
		};

		return (
			<Modal show={true} bsSize="large">
				<Modal.Header>
					<Modal.Title>Рассылка</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<section>
						<p>Выберите столбец и номер первой строки содержащие необходимые адреса электронной почты.</p>
						<Row>
							<Col xs={4}>
								<FormGroup>
									<ControlLabel>Лист</ControlLabel>
									<FormControl componentClass="select" value={sheetIndex} onChange={e => this.setState({sheetIndex: parseInt(e.target.value)})}>
										{sheets.map((sheet, index) => <option key={index} value={index}>{index + 1}</option>)}
									</FormControl>
								</FormGroup>
							</Col>
							<Col xs={4}>
								<FormGroup>
									<ControlLabel>Столбец</ControlLabel>
									<FormControl componentClass="select" value={selectedColumn} onChange={e => this.setState({selectedColumn: parseInt(e.target.value)})}>
										{columns.map((name, index) => <option key={index} value={index}>{name}</option>)}
									</FormControl>
								</FormGroup>
							</Col>
							<Col xs={4}>
								<FormGroup>
									<ControlLabel>Номер первой строки</ControlLabel>
									<FormControl componentClass="select" value={selectedRow} onChange={e => this.setState({selectedRow: parseInt(e.target.value)})}>
										{new Array(maxRowsShow).fill(true).map((n, index) => <option key={index} value={index}>{index + 1}</option>)}
									</FormControl>
								</FormGroup>
							</Col>
						</Row>

						<div className="sheetTableContainer">
							<Table>
								<thead>
								<tr>
									<th width="40" />
									{columns.map((name, index) => <th key={index}>{name}</th>)}
								</tr>
								</thead>
								<tbody>
								{sheetFiltered.map((row, rowIndex) =>
									<tr key={rowIndex} className={(rowIndex >= selectedRow ? 'selectedRow' : '') + (rowIndex === selectedRow ? ' selectedRowFirst' : '')}>
										<td>{rowIndex + 1}</td>
										{columns.map((name, colIndex) =>
											<td key={colIndex} className={colIndex === selectedColumn ? 'selectedColumn' : ''}>
												{row[colIndex] || null}
											</td>)}
									</tr>
								)}
								</tbody>
							</Table>
							<div className="sheetTableGradient" />
						</div>
					</section>
				</Modal.Body>

				<Modal.Footer>
					<Button onClick={nextStep} bsStyle="primary">Далее</Button>
					<Button onClick={onClose}>Закрыть</Button>
				</Modal.Footer>
			</Modal>
		);
	}

	appendRecipientFromState()
	{
		const email = this.state.appendRecipientEmail;
		const {event, reminder} = this.props;

		Request.post(`/api/cp/event/${event.eventPassword}/reminder/${reminder.id}/recipient`, {emails: [email]})
			.then((appendedRecipients) => {
				const recipients = this.state.recipients.slice()
					.concat(appendedRecipients)
				;

				this.setState({recipients, appendRecipientEmail: ''});
			})
		;
	}

	removeRecipient({id})
	{
		const {event} = this.props;

		Request.delete(`/api/cp/event/${event.eventPassword}/reminder/recipient/${id}`)
			.then(() => {
				const recipients = this.state.recipients.slice();
				let index = recipients.findIndex(r => r.id === id);
				if (index >= 0) {
					recipients.splice(index, 1);
					this.setState({recipients});
				}
			})
		;
	}

    sanitizeSenderAddress(text) {
        text = text.replace(/[^a-z0-9_.\-]/, '');
        text = text.replace(/^[._\-]+/, '');
        text = text.replace(/[._\-]+$/, '');

        return text;
    }

	renderRecipients()
	{
		const {recipients} = this.state;

		const onClose = () => {
			this.setState({view: 'reminder'});
		};

		return (
			<Modal show={true} bsSize="large">
				<Modal.Header>
					<Modal.Title>Рассылка</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<Table>
						<thead>
						<tr>
							<th>eMail</th>
							<th style={{width: 40}}>
								<Button onClick={this.showReceiversFileRequest.bind(this)}>Загрузить участников в excel</Button>
							</th>
						</tr>
						</thead>
						<tbody>
						{recipients.map((recipient, index) => <tr key={index}>
							<td>{recipient.email}</td>
							<td style={{textAlign: 'right'}}>
								<Button onClick={() => this.removeRecipient(recipient)}><Glyphicon glyph="trash" /></Button>
							</td>
						</tr>)}
						</tbody>
					</Table>
					<FormGroup>
						<InputGroup>
							<FormControl type="text" value={this.state.appendRecipientEmail}
										 onChange={e => this.setState({appendRecipientEmail: e.target.value})}
										 placeholder="email@example.com"
							/>
							<InputGroup.Button>
								<Button onClick={this.appendRecipientFromState.bind(this)}>
									Добавить
								</Button>
							</InputGroup.Button>
						</InputGroup>
					</FormGroup>
				</Modal.Body>

				<Modal.Footer>
					<Button onClick={onClose}>Закрыть</Button>
				</Modal.Footer>
			</Modal>
		);
	}

	renderEditForm()
	{
		const {reminder, onClose, onSave} = this.props;

		const setSendAtFromPicker = (event, picker) => {
			this.setState({sendAt: picker.startDate.unix()});
		};

		const onChangeSendType = (sendType) => {
			this.setState({sendType});
			if (sendType !== 'time') {
				this.setState({sendAt: null});
			}
		};

		let Receivers = () => <div>Авторизованные зрители</div>;

		if (reminder.recipientsSource === 'custom') {
			Receivers = () => <div>
				<ButtonGroup>
					<Button onClick={this.showRecipients.bind(this)}>Добавить участников / Посмотреть список участников</Button>
				</ButtonGroup>
			</div>
		} else if (reminder.recipientsSource === 'ticket') {
			Receivers = () => <div>Владельцы билетов</div>
		}

		return (
			<Modal show={true} bsSize="large" enforceFocus={false}>
				<Modal.Header>
					<Modal.Title>Рассылка</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<Form>
						<FormGroup>
							<ControlLabel>Получатели</ControlLabel>
							<Receivers/>
						</FormGroup>
						<Row>
							<Col xs={6}>
								<FormGroup>
									<ControlLabel>Способ рассылки</ControlLabel>
									<FormControl componentClass="select" value={this.state.sendType} onChange={e => onChangeSendType(e.target.value)}>
										<option value="time">В заданное время</option>
										<option value="manual">Вручную</option>
									</FormControl>
								</FormGroup>
							</Col>
							{this.state.sendType === 'time' ? <Col xs={6}>
								<FormGroup>
									<ControlLabel>Время отправки</ControlLabel>
									<DatetimeRangePicker
										singleDatePicker
										timePicker
										timePicker24Hour
										showDropdowns
										onApply={setSendAtFromPicker}
									>
										<FormControl
											type="text"
											value={this.state.sendAt ? moment.unix(this.state.sendAt).format('YYYY-MM-DD HH:mm') : ''}
										/>
									</DatetimeRangePicker>
								</FormGroup>
							</Col>: null}
						</Row>
						<Row>
							<Col xs={4}>
								<ControlLabel>eMail отправителя</ControlLabel>
								<FormGroup>
									<InputGroup>
										<FormControl
											type="text"
											value={this.state.senderEmail || ''}
											onChange={e => this.setState({senderEmail: this.sanitizeSenderAddress(e.target.value)})}
										/>
										<InputGroup.Addon>@comdi.com</InputGroup.Addon>
									</InputGroup>
								</FormGroup>
							</Col>
							<Col xs={4}>
								<FormGroup>
									<ControlLabel>Имя отправителя</ControlLabel>
									<FormControl
										type="text"
										value={this.state.senderName || ''}
										onChange={e => this.setState({senderName: e.target.value})}
									/>
								</FormGroup>
							</Col>
                            <Col xs={4}>
                                <FormGroup>
                                    <ControlLabel>Постер</ControlLabel>
                                    <div>
                                        <FormControl
                                            type="file"
                                            inputRef={ref => this.posterUploadRef = ref}
                                            style={{display: 'none'}}
                                            onChange={e => this.handlePosterSelect(e)}
                                        />
                                        <ButtonGroup>
                                            <Button onClick={() => this.handlePosterSelectClick()}>Загрузить</Button>
                                            {(this.state.posterUrl || (this.state.posterFile && this.state.posterFile !== 'DELETE')) &&
                                                <Button onClick={() => this.handlePosterDelete()}>Удалить</Button>
                                            }
                                            {this.state.posterUrl &&
                                                <Button href={this.state.posterUrl} target="_blank">Открыть</Button>
                                            }
                                        </ButtonGroup>
                                    </div>
                                </FormGroup>
                            </Col>
						</Row>
						<FormGroup>
							<ControlLabel>Тема письма</ControlLabel>
							<FormControl
								type="text"
								value={this.state.subject || ''}
								onChange={e => this.setState({subject: e.target.value})}
							/>
						</FormGroup>
						<FormGroup>
							<ControlLabel>Текст письма</ControlLabel>
							<RichEditor
								value={this.state.text || ''}
								onChange={e => this.setState({text: e.editor.getData()})}
							/>
							<div>
								{"Плейсхолдеры: {eventName} {datetimeStart} {dateStart} {timeStart}"}
							</div>
						</FormGroup>
                        <Row>
                            <Col xs={8}>
                                <Checkbox
                                    checked={this.state.watchButton}
                                    onChange={e => this.setState({watchButton: e.target.checked})}
                                >Кнопка "Смотреть"</Checkbox>
                                <Checkbox
                                    checked={this.state.offlineButton}
                                    onChange={e => this.setState({offlineButton: e.target.checked})}
                                >Кнопка "Офлайн участия"</Checkbox>
                                <Checkbox
                                    checked={this.state.calendarButton}
                                    onChange={e => this.setState({calendarButton: e.target.checked})}
                                >Кнопка "Добавить в календарь"</Checkbox>
                                <Checkbox
                                    checked={this.state.testSystemButton}
                                    onChange={e => this.setState({testSystemButton: e.target.checked})}
                                >Кнопка "Проверить подключение"</Checkbox>
                            </Col>
                            <Col xs={4}>
                                <div style={{textAlign: 'right'}}>
                                    <Button onClick={this.showEmailPreview.bind(this)}>Сохранить и просмотреть письмо</Button>
                                </div>
                            </Col>
                        </Row>
					</Form>
				</Modal.Body>

				<Modal.Footer>
					<Button onClick={() => this.saveChanges()}>Сохранить</Button>
					<Button onClick={onClose}>Закрыть</Button>
				</Modal.Footer>
			</Modal>
		);
	}

	renderEmailPreview()
	{
		const {reminder, event} = this.props;

		const onClose = () => this.setState({view: null});
		const frameStyle = {
			width: '100%',
			height: '500px',
			border: 'solid 1px #ccc'
		};
		const frameSrc = `/api/cp/event/${event.eventPassword}/reminder/${reminder.id}/emailPreview`;

		return (
			<Modal show={true} bsSize="large">
				<Modal.Header>
					<Modal.Title>Рассылка</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<iframe src={frameSrc} style={frameStyle} />
				</Modal.Body>

				<Modal.Footer>
					<Button onClick={onClose}>Закрыть</Button>
				</Modal.Footer>
			</Modal>
		);
	}

	render()
	{
		const {reminder} = this.props;
		const {view} = this.state;

		if (!reminder) {
			return null;
		}

		if (this.state.sheets) {
			return this.renderSheets();
		}

		if (view === 'recipients') {
			return this.renderRecipients();
		}

		if (view === 'email_preview') {
			return this.renderEmailPreview();
		}

		return this.renderEditForm();
	}
}

class RemindersPage extends React.Component
{
	state = {
		isLoaded: false,
		reminders: null,
		currentReminder: null
	};

	componentDidMount()
	{
		const {event} = this.props;

		Request.get(`/api/cp/event/${event.eventPassword}/reminder`)
			.then(reminders => this.setState({reminders, isLoaded: true}))
	}

	showEditor(reminder)
	{
		this.setState({currentReminder: reminder});
	}

	hideEditor()
	{
		this.setState({currentReminder: null});
	}

	createReminder(recipientsSource)
	{
		const {event} = this.props;

		const data = {
			sendAt: null,
			recipientsSource,
		};

		Request.post(`/api/cp/event/${event.eventPassword}/reminder`, data)
			.then(reminder => {
				const reminders = this.state.reminders.slice();
				reminders.push(reminder);

				this.setState({reminders});

				this.showEditor(reminder);
			});
	}

	updateReminder(reminder, data)
	{
		const {event} = this.props;
		const {currentReminder} = this.state;

		return Request.post(`/api/cp/event/${event.eventPassword}/reminder/${reminder.id}`, data)
			.then(newReminder => {
				const reminders = this.state.reminders.slice();
				const index = reminders.findIndex(r => r.id === newReminder.id);
				if (index >= 0) {
					reminders[index] = newReminder;
					this.setState({reminders});
				}

				if (currentReminder && currentReminder.id === newReminder.id) {
					this.setState({currentReminder: newReminder});
				}
			})
		;
	}

	submitReminder(reminder)
	{
		const {event} = this.props;

		if (!confirm('Отправить рассылку сейчас?')) {
			return;
		}

		Request.post(`/api/cp/event/${event.eventPassword}/reminder/${reminder.id}/send`)
			.then(() => alert('Рассылка будет обработана в ближайшее время'))
		;
	}

	removeReminder(reminder)
	{
		const {event} = this.props;

		if (!confirm('Удалить рассылку?')) {
			return;
		}

		fetch(`/api/cp/event/${event.eventPassword}/reminder/${reminder.id}`, {method: 'DELETE'})
			.then(response => {
				if (!response.ok) {
					alert('Не удалось удалить рассылку');

					return;
				}

				const reminders = this.state.reminders.slice();
				const index = reminders.findIndex(r => r.id === reminder.id);
				if (index >= 0) {
					reminders.splice(index, 1);
					this.setState({reminders});
				}
			})
		;
	}

	render()
	{
		const {event} = this.props;
		const {isLoaded, reminders, currentReminder} = this.state;

		if (!isLoaded) {
			return <Loading />
		}

		const reminderTypes = {
			registered: 'Для авторизованных',
			custom: 'Заданный список',
		};

		if (event.private) {
			reminderTypes['ticket'] = 'Для владельцев билетов';
		}

		return (
			<section className="event-reminders">
				<Row>
					<Col xs={10}>
						<Breadcrumb>
							<LinkContainer to={`/event/${event.eventPassword}`}><Breadcrumb.Item>Трансляция</Breadcrumb.Item></LinkContainer>
							<Breadcrumb.Item active>Рассылка</Breadcrumb.Item>
						</Breadcrumb>
					</Col>
					<Col xs={2} style={{textAlign: 'right'}}>
						<DropdownButton
							title="Добавить рассылку"
							onSelect={this.createReminder.bind(this)}
							id="createReminderButton"
						>
							{Object.keys(reminderTypes).map((type) => (
								<MenuItem eventKey={type} key={type} id={`createReminder_${type}`}>{reminderTypes[type]}</MenuItem>
							))}
						</DropdownButton>
					</Col>
				</Row>

				<ReminderEditor
					event={event}
					reminder={currentReminder}
					onSave={this.updateReminder.bind(this)}
					onClose={this.hideEditor.bind(this)}
				/>

				<RemindersTable
					event={event}
					reminders={reminders}
					onEdit={this.showEditor.bind(this)}
					onSubmit={this.submitReminder.bind(this)}
					onDelete={this.removeReminder.bind(this)}
				/>
			</section>
		);
	}
}

const mapStateToProps = (store) => ({
	event: store.currentEvent
});

export default connect(mapStateToProps)(RemindersPage);
